import './404.css'
import SEO from '../../Components/SEO/SEO';

const PageNotFound = () => {
    return (
        <>
            <SEO 
                title="Page Not Found"
                description="The page you're looking for doesn't exist. Explore Yassine Bazgour's portfolio, projects, blog, and more."
                url="https://yassinebazgour.vercel.app/404"
                keywords="404, page not found"
            />
            <div className='page-not-found-bg'></div>
            <section className='page-not-found-section'>
                <div className='pnf-text-content'>
                    <span className='pnf-404'>
                        404
                    </span>
                    <span className='pnf-title'>
                        OOPS! LOOKS LIKE THIS PAGE GOT LOST IN THE MATRIX
                    </span>
                    <span className='pnf-sub-title'>
                        You take the blue pill, the story ends, you end up in the oblivion, 
                        and believe whatever you want to believe. You take the red pill, 
                        you go to wonderland, and I will show you some magic.
                    </span>
                </div>
                <div className='pnf-buttons-container'>
                    <button 
                        className='pnf-buttons red-pill' 
                        onClick={() => {window.location.href = 'https://yassinebazgour.vercel.app/'}}
                    >
                        HOMEPAGE
                    </button>
                    <button 
                        className='pnf-buttons blue-pill' 
                        onClick={() => {window.location.href = 'https://www.google.com/search?sxsrf=AE3TifMVanGmMcWB0gi3Xh9hiUXmNKhaVQ:1749082491608&q=cat&udm=2'}}
                    >
                        LIMBO
                    </button>
                </div>
            </section>
        </>
    )
}

export default PageNotFound